import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const PointsTypography = styled(Typography)({
  right: '20px'
}); 

export interface ColorProps {
  $color: string;
  $fontSize: number;
}

export interface VisibilityProps {
  $visible: boolean;
}

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "stretch",
  backgroundColor: theme.palette.background.default,
  marginLeft: theme.spacing(4),
  width: "100%",
}));

export const LeftColumn = styled(Box)({
  flex: 1,
});

export const QuestionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.25),
}));

export const QuestionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$fontSize",
})<{ $fontSize: number }>(({ theme, $fontSize }) => ({
  fontWeight: 700,
  fontSize: $fontSize,
  marginLeft: theme.spacing(6),
}));

export const AnswersWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
}));

// Arrow | Index | Text | Points
export const Row = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "28px 28px 1fr 70px",
  alignItems: "center",
  columnGap: theme.spacing(1),
}));

export const ArrowCell = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$visible",
})<VisibilityProps>(({ theme, $visible }) => ({
  display: "flex",
  justifyContent: "center",
  marginRight: theme.spacing(-4),
  visibility: $visible ? "visible" : "hidden",
}));

export const IndexText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$color" && prop !== "$fontSize",
})<ColorProps>(({ $color, $fontSize }) => ({
  fontSize: $fontSize,
  textAlign: "center",
  color: $color,
}));

export const AnswerText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$color" && prop !== "$fontSize",
})<ColorProps>(({ theme, $color, $fontSize }) => ({
  fontSize: $fontSize,
  color: $color,
  marginLeft: theme.spacing(-1),
}));

export const PointsText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$color" && prop !== "$fontSize",
})<ColorProps>(({ theme, $color, $fontSize }) => ({
  fontSize: $fontSize,
  textAlign: "right",
  color: $color,
  marginLeft: theme.spacing(9),
}));

export const TimeBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minWidth: 72,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginLeft: theme.spacing(7.5),
}));

export const TimeText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$fontSize",
})<{ $fontSize: number }>(({ $fontSize }) => ({
  fontSize: $fontSize,
}));
